/*globals jQuery */

var $ = jQuery;

$.fn.sticky = function () {
    var ele = $(this);

    if (!ele.exists()) {
        return;
    }

    ele.css("left", ele.position().left);
    ele.css("top", $("header").height());

    ele.affix({
        offset: { 
            top: ele.offset().top - $("header").height()
        }
    });

    // $(document).on("scroll", function () {
    //     var topBounds = $(document).scrollTop() + $("header").height(),
    //     bottomBounds,
    //     elePosition = ele.offset().top;

    //     console.log(topBounds);
    //     console.log(elePosition);

    //     if (topBounds >= elePosition) {
    //         ele.addClass("entered-scroll-bounds");
    //     }
    // });
};